import React from 'react';

const INK = '#333';
const MUTED = '#999';
const FILL = '#efefef';

/* "तारीख पर तारीख" — crossed-out calendar dates leading to the ballot box */
const RajasthanChunavVisual = ({ title }) => (
  <svg
    viewBox="0 0 720 240"
    role="img"
    aria-label={title}
    xmlns="http://www.w3.org/2000/svg"
    style={{
      display: 'block',
      width: '100%',
      height: 'auto',
      background: '#fafafa',
      borderRadius: 14,
      boxShadow: '0 8px 24px rgba(0,0,0,.08)',
      margin: '24px 0 32px',
    }}
  >
    {[
      { x: 40, label: 'जन 2025' },
      { x: 200, label: '2025' },
      { x: 360, label: '2026' },
    ].map(({ x, label }) => (
      <g key={x}>
        <rect x={x} y="60" width="110" height="110" fill="#fff" stroke={INK} strokeWidth="2" />
        <rect x={x} y="60" width="110" height="28" fill={FILL} stroke={INK} strokeWidth="2" />
        <text x={x + 55} y="80" fontSize="15" fontFamily="Arial, 'Noto Sans Devanagari', sans-serif" fill={INK} textAnchor="middle">{label}</text>
        <line x1={x + 18} y1="102" x2={x + 92} y2="156" stroke={MUTED} strokeWidth="4" />
        <line x1={x + 92} y1="102" x2={x + 18} y2="156" stroke={MUTED} strokeWidth="4" />
      </g>
    ))}
    <path d="M 490 115 L 530 115 M 522 105 L 534 115 L 522 125" fill="none" stroke={INK} strokeWidth="3" />
    <rect x="550" y="90" width="120" height="80" fill="#fff" stroke={INK} strokeWidth="2.5" />
    <rect x="592" y="76" width="36" height="12" fill={INK} />
    <path d="M 596 66 L 610 80 L 632 52" fill="none" stroke={INK} strokeWidth="4" />
    <text x="610" y="140" fontSize="16" fontFamily="Arial, 'Noto Sans Devanagari', sans-serif" fill={INK} textAnchor="middle" fontWeight="bold">15 नवंबर</text>
    <text x="610" y="158" fontSize="12" fontFamily="Arial, 'Noto Sans Devanagari', sans-serif" fill={MUTED} textAnchor="middle">2026</text>
    <text x="360" y="215" fontSize="14" fontFamily="Arial, 'Noto Sans Devanagari', sans-serif" fill={MUTED} textAnchor="middle">
      तारीख पर तारीख… अब आख़िरी मौका
    </text>
  </svg>
);

/* Map each post slug to its visual */
export const BLOG_VISUALS = {
  'rajasthan-panchayat-chunav-kyon-tal-rahe-hain': RajasthanChunavVisual,
};
